<template>
  <main class="rail-service" v-bind="dKey('pageid', pageName, postId)">
    <div class="fixed-video"><img src="/static-assets/vid/img/rail/large/0001.jpg" alt="" /></div>
    <section class="in1">
      <div class="container">
        <div class="hb1">
          <div class="hb-linr"></div>
          <div v-bind="dKey('title')" class="text-hb">{{info.title}}</div>
        </div>
        <div class="title-fs">
          <h1 v-bind="dKey('weTitle')" class="text-center" v-html="info.weTitle"></h1>
          <h2 class="text-center"><span v-bind="dKey('weSubtitle')">{{info.weSubtitle}}</span><div v-bind="dKey('weSubtitle2')">{{info.weSubtitle2}}</div></h2>
        </div>
      </div>
    </section>

    <section class="in2">
      <div class="container has-paralax">
        <div id="id-0" data-pos="5" data-speed="1.2" class="paralax left">
          <div class="braund">
            <div class="bra-top">
              <svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" width="64" height="61" viewBox="0 0 64 61"><defs><path id="4hpia" d="M481.067 254.187l-13.26 4.837a1.275 1.275 0 0 1-1.638-.746 1.257 1.257 0 0 1 .756-1.62l13.259-4.836a1.28 1.28 0 0 1 1.638.746 1.256 1.256 0 0 1-.755 1.619zm-16.905 6.167l-.561.205a1.275 1.275 0 0 1-1.638-.746 1.257 1.257 0 0 1 .755-1.62l.562-.204a1.279 1.279 0 0 1 1.637.746 1.256 1.256 0 0 1-.755 1.619zm16.905-11.303l-10.478 3.822a1.275 1.275 0 0 1-1.638-.746 1.257 1.257 0 0 1 .755-1.62l10.478-3.822a1.28 1.28 0 0 1 1.638.747 1.256 1.256 0 0 1-.755 1.619zm0-5.083l-10.478 3.822a1.275 1.275 0 0 1-1.638-.746 1.257 1.257 0 0 1 .755-1.619l10.478-3.823a1.28 1.28 0 0 1 1.638.747 1.256 1.256 0 0 1-.755 1.619zm5.933-23.5v36.063c0 .528-.333 1-.834 1.182l-30.725 11.21v-.002a1.288 1.288 0 0 1-.882.001l-30.726-11.209a1.261 1.261 0 0 1-.833-1.182v-36.063a1.257 1.257 0 0 1 .833-1.182l30.726-11.21a1.29 1.29 0 0 1 .882 0l30.725 11.21c.501.182.834.654.834 1.182zm-33.275 45.463zm0 0v-33.376l-6.12-2.232v14.342c0 .412-.204.799-.546 1.034a1.285 1.285 0 0 1-1.17.149l-13.769-5.023a1.261 1.261 0 0 1-.833-1.183V224.37l-5.737-2.093v33.375zM433.837 225.3v13.463l11.219 4.093v-13.463zm12.494 1.86l10.086-3.679-10.086-3.68-10.086 3.68zm35.711-6.692L455 210.603l-27.042 9.865 4.59 1.675 13.341-4.868a1.29 1.29 0 0 1 .883 0l13.769 5.023c.5.183.833.655.833 1.183s-.332 1-.833 1.182L450 228.51l5 1.824zm2.408 1.809l-28.175 10.278v33.376l28.175-10.279z"/></defs><g><g transform="translate(-423 -208)"><use fill="#fff" xlink:href="#4hpia"/></g></g></svg>
            </div>
            <div class="bra-content">
              <span v-bind="dKey('weList#0')">{{getData('weList', 0)}}</span>
            </div>
          </div>
        </div>
        <div id="id-1" data-pos="8" data-speed="1.2" class="paralax right">
          <div class="braund">
            <div class="bra-top">
              <svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" width="64" height="73" viewBox="0 0 64 73"><defs><path id="7j2fa" d="M1254.508 469.528a1.398 1.398 0 0 1-.995-.418 1.445 1.445 0 0 1-.384-1.286 1.434 1.434 0 0 1 .842-1.038 1.388 1.388 0 0 1 1.532.308 1.385 1.385 0 0 1 .306.463 1.434 1.434 0 0 1-.762 1.862 1.399 1.399 0 0 1-.539.109zM1235 423.918a1.417 1.417 0 0 1-1.408-1.426v-.8h-.788a1.417 1.417 0 0 1-1.407-1.426c0-.787.63-1.426 1.407-1.426h.788v-.8c0-.787.63-1.425 1.408-1.425.777 0 1.407.638 1.407 1.426v.8h.788c.778 0 1.408.638 1.408 1.425 0 .788-.63 1.426-1.408 1.426h-.788v.8c0 .787-.63 1.425-1.407 1.425zm27.985 38.86v10.649h2.607c.778 0 1.408.638 1.408 1.425v6.722c0 .788-.63 1.426-1.408 1.426h-61.185a1.417 1.417 0 0 1-1.407-1.426v-6.721c0-.788.63-1.426 1.407-1.426h2.608v-10.649h-2.608a1.417 1.417 0 0 1-1.407-1.425v-6.723c0-.787.63-1.426 1.407-1.426h12.56l14.685-8.955a6.048 6.048 0 0 1-2.599-4.98c0-2.832 1.937-5.214 4.54-5.856v-2.98c-4.922-.697-8.721-4.99-8.721-10.167 0-5.66 4.543-10.266 10.128-10.266s10.129 4.605 10.129 10.266c0 5.177-3.8 9.47-8.722 10.167v4.235c0 .787-.63 1.425-1.407 1.425-1.727 0-3.132 1.425-3.132 3.176 0 1.752 1.405 3.176 3.132 3.176s3.132-1.424 3.132-3.176c0-.787.63-1.426 1.408-1.426.777 0 1.407.64 1.407 1.426a6.05 6.05 0 0 1-2.6 4.98l14.686 8.955h12.56c.777 0 1.407.64 1.407 1.426v6.722c0 .788-.63 1.426-1.408 1.426zM1235 427.68c4.032 0 7.313-3.326 7.313-7.415 0-4.088-3.28-7.414-7.313-7.414-4.033 0-7.313 3.326-7.313 7.414 0 4.089 3.28 7.415 7.313 7.415zm-12.576 25.523h25.151L1235 445.535zm-16.609 6.722h58.37v-3.87h-58.37zm58.37 16.352h-58.37v3.87h58.37zm-4.015-13.5h-50.34v3.898h38.726c.778 0 1.408.639 1.408 1.426 0 .788-.63 1.426-1.408 1.426h-38.726v3.899h50.34z"/></defs><g><g transform="translate(-1203 -410)"><use fill="#fff" xlink:href="#7j2fa"/></g></g></svg>
            </div>
            <div class="bra-content">
              <span v-bind="dKey('weList#1')">{{getData('weList', 1)}}</span>
            </div>
          </div>
        </div>
        <div id="id-2" data-pos="11" data-speed="1.2" class="paralax left">
          <div class="braund">
              <div class="bra-top">
                <svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" width="74" height="72" viewBox="0 0 74 72"><defs><path id="54f1a" d="M492 672.812c0 .622-.037 1.269-.111 1.921a1.437 1.437 0 0 1-1.437 1.267h-71.007c-.383 0-.75-.15-1.022-.417a1.414 1.414 0 0 1-.423-1.008c0-2.192.458-4.312 1.361-6.3 2.52-5.542 8.13-9.124 14.294-9.124.408 0 .82.016 1.234.049a20.89 20.89 0 0 1 7.123-7.395 21.092 21.092 0 0 1 8.339-2.994l5.617-11.324-.004-.002a1.416 1.416 0 0 1-.665-1.906c.35-.707 1.216-1 1.933-.655l5.443 2.62 1.56-3.144c.35-.707 1.216-1 1.933-.655l.347.168 9.949-20.06a8.496 8.496 0 0 1-.412-.584 6.548 6.548 0 0 1-.36-6.423l.176-.353a1.411 1.411 0 0 1-.341-1.693c.35-.707 1.215-1 1.933-.655l12.809 6.168a1.415 1.415 0 0 1 .664 1.905 1.446 1.446 0 0 1-1.566.775l-.175.355c-1.013 2.042-3.069 3.446-5.364 3.666a8.635 8.635 0 0 1-.727.038l-9.948 20.057.346.167c.345.166.608.46.733.817.124.358.1.75-.069 1.089l-1.56 3.144 5.442 2.62a1.415 1.415 0 0 1 .665 1.905c-.25.506-.765.8-1.3.8-.213 0-.429-.046-.633-.145l-.006-.003-4.077 8.218a17.817 17.817 0 0 1 1.86-.097c7.958 0 14.905 5.296 16.893 12.878.367 1.4.553 2.85.553 4.31zm-5.253-61.023l-8.305-4-.153.309a3.716 3.716 0 0 0 .205 3.645 5.373 5.373 0 0 0 5.055 2.434 3.823 3.823 0 0 0 3.046-2.081zm-17.634 23.374l1.443.695 9.58-19.316a8.273 8.273 0 0 1-1.443-.695zm-3.84 3.633l4.733 2.28.926-1.866-4.734-2.28zm-6.707-.059l-4.905 9.887c6.05.13 11.78 2.86 15.656 7.418l4.856-9.79zm30.543 34.075c0-.851-.075-1.698-.226-2.529h-37.26a1.435 1.435 0 0 1-1.445-1.424c0-.787.647-1.425 1.446-1.425h36.429c-2.193-5.358-7.502-8.961-13.498-8.961-1.37 0-2.716.186-4.015.553l-.033.009c-.326.092-.647.197-.967.312a1.458 1.458 0 0 1-1.667-.5c-3.403-4.62-8.884-7.378-14.663-7.378-6.91 0-13.122 3.79-16.212 9.89a1.45 1.45 0 0 1-1.499.774c-4.928-.702-9.658 1.462-12.352 5.3h9.74c.799 0 1.446.638 1.446 1.425s-.647 1.425-1.445 1.425h-11.235a12.28 12.28 0 0 0-.682 2.868h68.134c.003-.115.004-.227.004-.34z"/></defs><g><g transform="translate(-418 -604)"><use fill="#fff" xlink:href="#54f1a"/></g></g></svg>
              </div>
              <div class="bra-content">
                <span v-bind="dKey('weList#2')">{{getData('weList', 2)}}</span>
              </div>
            </div>
        </div>
        <div id="id-3" data-pos="13" data-speed="1.2" class="paralax right">
          <div class="braund">
              <div class="bra-top">
                <svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" width="67" height="58" viewBox="0 0 67 58"><defs><path id="765qa" d="M488.225 262.92a6.022 6.022 0 0 1-5.241 3.08h-54.968a6.022 6.022 0 0 1-5.241-3.08 6.103 6.103 0 0 1 .086-6.108l27.484-45.882A6.044 6.044 0 0 1 455.5 208a6.044 6.044 0 0 1 5.155 2.93l27.483 45.882a6.103 6.103 0 0 1 .087 6.108zm-3.822-3.84l-27.484-45.882a1.664 1.664 0 0 0-1.419-.807c-.577 0-1.121.31-1.42.807l-27.483 45.882a1.68 1.68 0 0 0-.024 1.681c.294.523.847.848 1.443.848h54.968c.596 0 1.149-.325 1.442-.848a1.68 1.68 0 0 0-.023-1.681zm-25.969-30.528c0 4.848-.566 11.815-.566 16.663 0 1.263-1.376 1.792-2.348 1.792-1.295 0-2.388-.53-2.388-1.792 0-4.848-.566-11.815-.566-16.663 0-1.589 1.295-2.485 2.954-2.485 1.579 0 2.914.896 2.914 2.485zm.203 24.404c0 1.67-1.417 3.137-3.076 3.137-1.781 0-3.117-1.467-3.117-3.137 0-1.712 1.336-3.138 3.117-3.138 1.66 0 3.076 1.426 3.076 3.138z"/></defs><g><g transform="translate(-422 -208)"><use fill="#fff" xlink:href="#765qa"/></g></g></svg>
              </div>
              <div class="bra-content">
                <span v-bind="dKey('weList#3')">{{getData('weList', 3)}}</span>
              </div>
            </div>
        </div>
      </div>
    </section>

    <section class="geography-title">
      <div class="container">
        <div class="title-fs">
          <h1 v-bind="dKey('geoTitle')" class="text-center">{{info.geoTitle}}</h1>
        </div>
      </div>
    </section>

    <section class="geography-content">
      <div class="container has-paralax">
        <div id="id-4" data-pos="27" data-speed="1.5" class="paralax left">
          <div class="c-block ma1">
            <div class="content-va">
              <span v-bind="dKey('geoList#0#strong')">{{getData('geoList', 0, 'strong')}}</span>
              <i v-bind="dKey('geoList#0#text')">{{getData('geoList', 0, 'text')}}</i>
            </div>
          </div>
        </div>
        <div id="id-5" data-pos="30" data-speed="1.5" class="paralax right">
          <div class="c-block ma2">
            <div class="content-va">
              <span v-bind="dKey('geoList#1#strong')">{{getData('geoList', 1, 'strong')}}</span>
              <i v-bind="dKey('geoList#1#text')">{{getData('geoList', 1, 'text')}}</i>
            </div>
          </div>
        </div>
        <div id="id-6" data-pos="33" data-speed="1.5" class="paralax left">
          <div class="c-block ma3">
            <div class="content-va">
              <span v-bind="dKey('geoList#2#strong')">{{getData('geoList', 2, 'strong')}}</span>
              <i v-bind="dKey('geoList#2#text')">{{getData('geoList', 2, 'text')}}</i>
            </div>
          </div>
        </div>
        <div id="id-7" data-pos="36" data-speed="1.5" class="paralax right">
          <div class="c-block ma4">
            <div class="content-va">
              <span v-bind="dKey('geoList#3#strong')">{{getData('geoList', 3, 'strong')}}</span>
              <i v-bind="dKey('geoList#3#text')">{{getData('geoList', 3, 'text')}}</i>
            </div>
          </div>
        </div>
        <div id="id-8" data-pos="39" data-speed="1.5" class="paralax left">
          <div class="c-block ma5">
            <div class="content-va">
              <span v-bind="dKey('geoList#4#strong')">{{getData('geoList', 4, 'strong')}}</span>
              <i v-bind="dKey('geoList#4#text')">{{getData('geoList', 4, 'text')}}</i>
            </div>
          </div>
        </div>
        <div id="id-9" data-pos="42" data-speed="1.5" class="paralax right">
          <div class="c-block ma6">
            <div class="content-va">
              <span v-bind="dKey('geoList#5#strong')">{{getData('geoList', 5, 'strong')}}</span>
              <i v-bind="dKey('geoList#5#text')">{{getData('geoList', 5, 'text')}}</i>
            </div>
          </div>
        </div>
        <div id="id-10" data-pos="45" data-speed="1.5" class="paralax left">
          <div class="c-block ma7">
            <div class="content-va">
              <span v-bind="dKey('geoList#6#strong')">{{getData('geoList', 6, 'strong')}}</span>
              <i v-bind="dKey('geoList#6#text')">{{getData('geoList', 6, 'text')}}</i>
            </div>
          </div>
        </div>
      </div>
    </section>

    <section class="flytry-title">
      <div class="container">
        <div class="title-fs">
          <h1 v-bind="dKey('capTitle')" class="text-center">{{info.capTitle}}</h1>
        </div>
      </div>
    </section>

    <section class="flytry-element">
      <div class="container has-paralax">
        <div id="id-11" data-pos="55" data-speed="1.5" class="paralax left">
          <div class="rond-r">
            <div class="clip-num align-middle">1</div>
            <div v-bind="dKey('capList#0')" class="clip-text align-middle">{{getData('capList', 0)}}</div>
          </div>
        </div>
        <div id="id-12" data-pos="58" data-speed="1.5" class="paralax right">
          <div class="rond-r">
            <div class="clip-num align-middle">2</div>
            <div v-bind="dKey('capList#1')" class="clip-text align-middle">{{getData('capList', 1)}}</div>
          </div>
        </div>
        <div id="id-13" data-pos="61" data-speed="1.5" class="paralax left">
          <div class="rond-r">
            <div class="clip-num align-middle">3</div>
            <div v-bind="dKey('capList#2')" class="clip-text align-middle">{{getData('capList', 2)}}</div>
          </div>
        </div>
        <div id="id-14" data-pos="64" data-speed="1.5" class="paralax right">
          <div class="rond-r">
            <div class="clip-num align-middle">4</div>
            <div v-bind="dKey('capList#3')" class="clip-text align-middle">{{getData('capList', 3)}}</div>
          </div>
        </div>
        <div id="id-15" data-pos="67" data-speed="1.5" class="paralax left">
          <div class="rond-r">
            <div class="clip-num align-middle">5</div>
            <div v-bind="dKey('capList#4')" class="clip-text align-middle">{{getData('capList', 4)}}</div>
          </div>
        </div>
      </div>
    </section>

    <section class="or">
      <div class="container">
        <div class="title-fs">
          <h1 v-bind="dKey('orTitle')" class="text-center" v-html="info.orTitle"></h1>
          <h2 class="text-center"><span v-bind="dKey('orSubtitle')">{{info.orSubtitle}}</span><div v-bind="dKey('weSubtitle2')">{{info.weSubtitle2}}</div></h2>
        </div>
      </div>
    </section>

    <section class="flytry-element flytry-or">
      <div class="container has-paralax">
        <div id="id-16" data-pos="75" data-speed="1.5" class="paralax left">
          <div class="rond-r">
            <div class="clip-num align-middle">1</div>
            <div v-bind="dKey('orList#0')" class="clip-text align-middle">{{getData('orList', 0)}}</div>
          </div>
        </div>
        <div id="id-17" data-pos="78" data-speed="1.5" class="paralax right">
          <div class="rond-r">
            <div class="clip-num align-middle">2</div>
            <div v-bind="dKey('orList#1')" class="clip-text align-middle">{{getData('orList', 1)}}</div>
          </div>
        </div>
        <div id="id-18" data-pos="81" data-speed="1.5" class="paralax left">
          <div class="rond-r">
            <div class="clip-num align-middle">3</div>
            <div v-bind="dKey('orList#2')" class="clip-text align-middle">{{getData('orList', 2)}}</div>
          </div>
        </div>
        <div id="id-19" data-pos="84" data-speed="1.5" class="paralax right">
          <div class="rond-r">
            <div class="clip-num align-middle">4</div>
            <div v-bind="dKey('orList#3')" class="clip-text align-middle">{{getData('orList', 3)}}</div>
          </div>
        </div>
        <div id="id-20" data-pos="87" data-speed="1.5" class="paralax left">
          <div class="rond-r">
            <div class="clip-num align-middle">5</div>
            <div v-bind="dKey('orList#4')" class="clip-text align-middle">{{getData('orList', 4)}}</div>
          </div>
        </div>
        <div id="id-21" data-pos="90" data-speed="1.5" class="paralax right">
          <div class="rond-r">
            <div class="clip-num align-middle">6</div>
            <div v-bind="dKey('orList#5')" class="clip-text align-middle">{{getData('orList', 5)}}</div>
          </div>
        </div>
        <div id="id-22" data-pos="93" data-speed="1.5" class="paralax left">
          <div class="rond-r">
            <div class="clip-num align-middle">7</div>
            <div v-bind="dKey('orList#6')" class="clip-text align-middle">{{getData('orList', 6)}}</div>
          </div>
        </div>
      </div>
    </section>

    <span v-if="$root.isAdmin()" v-bind="dKey('url')" class="hidden">{{url}}</span>
  </main>
</template>

<script>

import {HTTP} from '../http-common'

export default {
  name: 'ServiceRail',

  data() {
    return {
      url: 'rail-freight',
      animLoaded: false,
      info: {},
      postId: 0,
      pageName: 'service_page',
      errors: []
    }
  },

  mounted() {
    document.querySelectorAll('[data-key]').forEach(function(node){
      node.contentEditable = true
    })
  },

  created() {
    this.$root.$emit('service_page', true)

    this.getPost()
  },

  watch:{
    $route () {
      this.getPost()
    }
  },

  methods: {
    dKey(key, page, pageId) {
      return this.$root.dKey(key, page, pageId)
    },

    getData(key, index, field) {
      if (this.info[key] && this.info[key][index])
        return field ? this.info[key][index][field] : this.info[key][index]
      return ''
    },

    getPost() {
      let self = this

      HTTP.get('posts?filter=' + encodeURIComponent(JSON.stringify({
        where: {
          and: [
            {type: 'service_page'},
            {url: this.url},
            {language_id: this.$root.language_id}
          ]
        }
      }))).then(response => {
        if (response.data.length) {
          self.info = response.data[0].json.length ? JSON.parse(response.data[0].json) : {}
          self.info.title = response.data[0].title
          self.info.id =
          self.postId = response.data[0].id
          self.info.url = response.data[0].url

          document.querySelector('title').text = response.data[0].meta_title.length
            ? response.data[0].meta_title
            : 'Antwerk'

          document.querySelector('meta[name="description"]').text = response.data[0].meta_description.length
            ? response.data[0].meta_description
            : ''

          if (!self.animLoaded) {
            setTimeout(function(){
              window.frameFolder = 'rail';
              window.frameCount = 512;

              self.$root.scriptLoader('/static-assets/js/img-anim.js?v=5.0', () => {
                self.animLoaded = true
              })
            }, 1000);
          }
        }
      }).catch(e => {
        self.errors.push(e)
      })
    }
  }
}

</script>
